import { template as _$template } from "solid-js/web";
import { delegateEvents as _$delegateEvents } from "solid-js/web";
import { createComponent as _$createComponent } from "solid-js/web";
import { effect as _$effect } from "solid-js/web";
import { setAttribute as _$setAttribute } from "solid-js/web";
import { insert as _$insert } from "solid-js/web";
var _tmpl$ = /*#__PURE__*/_$template(`<p class=tape-save__error data-testid=tape-save-error>`),
  _tmpl$2 = /*#__PURE__*/_$template(`<div class=tape-save data-testid=tape-save role=dialog aria-label="Save flight to a tape"><div class=tape-save__panel><p class=tape-save__eyebrow>MISSION RECORDER</p><h2 class=tape-save__headline>WOULD YOU LIKE TO SAVE THIS MISSION TO A TAPE?</h2><p class=tape-save__note> recorded · names are <!> characters, as they always were</p><label class=tape-save__field><span>TAPE NAME</span><input type=text class=tape-save__input data-testid=tape-save-name autocomplete=off></label><div class=tape-save__actions><button type=button class=tape-save__button>CANCEL</button><button type=button class="tape-save__button tape-save__button--primary"data-testid=tape-save-confirm>SAVE`);
import { createSignal, Show } from "solid-js";
import { TAPE_NAME_MAX, tapeName } from "@red-opus/engine";

/**
 * "Would you like to save this mission to a tape?" — verbatim from `RB.EXE`'s
 * own string table (docs/game/missions.md), which is what the original put up
 * the moment a sortie ended.
 *
 * The eight-character limit is the original's and is kept, along with its
 * behaviour: "If you type a name longer than 8 characters, the computer will
 * cut off the additional characters, saving only the first 8." The field simply
 * will not accept a ninth, which is the same outcome with none of the surprise.
 *
 * The one place this departs from the original is the clash: the original
 * overwrote a tape of the same name without asking, and this suggests a free
 * name instead, because losing a flight to a name collision is a worse surprise
 * than an odd digit on the end (`tape-store.ts`'s `freeTapeName`).
 */
export function SaveFlightPrompt(props) {
  const [name, setName] = createSignal(props.suggested);
  const cleaned = () => tapeName(name());
  return (() => {
    var _el$ = _tmpl$2(),
      _el$2 = _el$.firstChild,
      _el$3 = _el$2.firstChild,
      _el$4 = _el$3.nextSibling,
      _el$5 = _el$4.nextSibling,
      _el$6 = _el$5.firstChild,
      _el$8 = _el$6.nextSibling,
      _el$7 = _el$8.nextSibling,
      _el$9 = _el$5.nextSibling,
      _el$0 = _el$9.firstChild,
      _el$1 = _el$0.nextSibling,
      _el$11 = _el$9.nextSibling,
      _el$12 = _el$11.firstChild,
      _el$13 = _el$12.nextSibling;
    _$insert(_el$5, () => props.duration, _el$6);
    _$insert(_el$5, TAPE_NAME_MAX, _el$8);
    _el$1.$$input = event => setName(event.currentTarget.value);
    _$setAttribute(_el$1, "maxlength", TAPE_NAME_MAX);
    _$setAttribute(_el$1, "spellcheck", false);
    _$insert(_el$2, _$createComponent(Show, {
      get when() {
        return props.error;
      },
      get children() {
        var _el$10 = _tmpl$();
        _$insert(_el$10, () => props.error);
        return _el$10;
      }
    }), _el$11);
    _el$12.$$click = () => props.onCancel();
    _el$13.$$click = () => props.onSave(cleaned());
    _$effect(() => _el$1.value = name());
    return _el$;
  })();
}
_$delegateEvents(["input", "click"]);